import type { MetaDescriptor } from 'react-router';

/**
 * Утилита для создания метаданных страниц
 * @param title - Заголовок страницы
 * @param description - Описание страницы
 * @returns Массив метаданных для React Router
 */

const DEFAULT_TITLE = 'Панель управления';

export const createMeta = (
  title: string,
  description?: string
): MetaDescriptor[] => {
  const meta: MetaDescriptor[] = [{ title: `${title}, ${DEFAULT_TITLE}` }];

  if (description) {
    meta.push({ name: 'description', content: description });
  }

  return meta;
};
